export function parseStoredValue(value, initialValue, config, key) {
    if (!value)
        return initialValue;
    try {
        // If raw mode, return value directly
        if (config.raw) {
            return value;
        }
        // Otherwise parse as JSON
        return JSON.parse(value);
    }
    catch (error) {
        console.warn("Error parsing storage key \"".concat(key, "\":"), error);
        return initialValue;
    }
}
export function stringifyValue(value, config, key) {
    if (config.raw) {
        return value;
    }
    try {
        return JSON.stringify(value);
    }
    catch (error) {
        console.warn("Error stringifying value for storage key \"".concat(key, "\":"), error);
        return String(value);
    }
}
